import { c as _c } from "react/compiler-runtime";
import { Hint, Tooltip, centsToUnits } from '@systemeio/ui';
import StatisticsTabTableLayout from 'modules/funnels/funnel/components/statistics-tab/statistics-tab-table-layout';
import TabTable, { TabColumnDefinitionInterface } from 'modules/funnels/funnel/components/tab-table';
import { useFunnelStatistics } from 'modules/funnels/funnel/hooks/use-funnel-statistics';
import { FunnelStatisticsFilterInterface, FunnelStatisticsInterface, FunnelStepStatisticsInterface } from 'modules/funnels/funnel/types/funnel-statistics-interface';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useState } from 'react';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
interface SalesTabProps {
  funnelId: FunnelId;
  funnelStep: FunnelStepInterface | null;
}
const defaultFilters: FunnelStatisticsFilterInterface = {
  date: [null, null]
};
function StatisticsTab(t0) {
  const $ = _c(78);
  const {
    funnelId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const [filter, setFilter] = useState(defaultFilters);
  let t1;
  if ($[0] !== filter || $[1] !== funnelId) {
    t1 = {
      funnelId,
      filter
    };
    $[0] = filter;
    $[1] = funnelId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    statistics
  } = useFunnelStatistics(t1);
  if (!statistics) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex h-full items-center justify-center py-12"><Loader className="scale-150" /></div>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      key: "funnelStepName",
      header: " ",
      widthPercent: 15,
      subHeaders: [{
        widthPercent: 100,
        title: " ",
        onRender: _temp,
        onRenderSmall: _temp2,
        align: "justify-start"
      }]
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.funnel.statistics.page_views");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [{
      widthPercent: 100,
      title: " ",
      onRender: _temp3
    }];
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = {
      key: "funnelStepViews",
      header: t3,
      widthPercent: 7,
      subHeaders: t4
    };
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("dashboard.funnel.statistics.opt_in_title_hint");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("dashboard.funnel.statistics.opt_in_title");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <Hint label={t6}>{t7}</Hint>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("dashboard.funnel.statistics.all");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = {
      widthPercent: 30,
      title: t9,
      onRender: _temp4
    };
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("dashboard.funnel.statistics.conversion_rate");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = {
      widthPercent: 70,
      title: t11,
      onRender: _temp5
    };
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12) {
    t13 = [t10, t12];
    $[25] = t10;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t8) {
    t14 = {
      key: "optIns",
      header: t8,
      widthPercent: 20,
      subHeaders: t13
    };
    $[28] = t13;
    $[29] = t8;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t) {
    t15 = t("dashboard.funnel.statistics.sales");
    $[31] = t;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t) {
    t16 = t("dashboard.funnel.statistics.total");
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16) {
    t17 = {
      widthPercent: 20,
      title: t16,
      onRender: _temp6
    };
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t) {
    t18 = t("dashboard.funnel.statistics.conversion_rate");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t18) {
    t19 = {
      widthPercent: 30,
      title: t18,
      onRender: _temp7
    };
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t) {
    t20 = t("dashboard.funnel.statistics.revenue");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== statistics.currency || $[44] !== user?.dashboardLocale) {
    t21 = funnelStep_6 => <Tooltip mode="overflow" label={<>{funnelStep_6.salesGrossSum ? currencyFormat(centsToUnits(funnelStep_6.salesGrossSum), statistics.currency, user?.dashboardLocale) : "-"}</>} wrapperClassName="flex w-full h-full justify-center align-center" className="flex"><span className="truncate font-normal">{funnelStep_6.salesGrossSum ? currencyFormat(centsToUnits(funnelStep_6.salesGrossSum), statistics.currency, user?.dashboardLocale) : "-"}</span></Tooltip>;
    $[43] = statistics.currency;
    $[44] = user?.dashboardLocale;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t20 || $[47] !== t21) {
    t22 = {
      widthPercent: 50,
      title: t20,
      onRender: t21
    };
    $[46] = t20;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t17 || $[50] !== t19 || $[51] !== t22) {
    t23 = [t17, t19, t22];
    $[49] = t17;
    $[50] = t19;
    $[51] = t22;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t15 || $[54] !== t23) {
    t24 = {
      key: "sales",
      header: t15,
      widthPercent: 40,
      subHeaders: t23
    };
    $[53] = t15;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t) {
    t25 = t("dashboard.funnel.statistics.earning_pageview_title");
    $[56] = t;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== statistics.currency || $[59] !== user?.dashboardLocale) {
    t26 = [{
      widthPercent: 100,
      title: " ",
      onRender: funnelStep_7 => <Tooltip mode="overflow" label={<>{funnelStep_7.earningPerViewUnique ? currencyFormat(centsToUnits(funnelStep_7.earningPerViewUnique), statistics.currency, user?.dashboardLocale) : "-"}</>} wrapperClassName="flex w-full h-full justify-center align-center" className="flex"><span className="truncate font-normal">{funnelStep_7.earningPerViewUnique ? currencyFormat(centsToUnits(funnelStep_7.earningPerViewUnique), statistics.currency, user?.dashboardLocale) : "-"}</span></Tooltip>
    }];
    $[58] = statistics.currency;
    $[59] = user?.dashboardLocale;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t25 || $[62] !== t26) {
    t27 = {
      key: "earning/preview",
      header: t25,
      widthPercent: 12,
      subHeaders: t26
    };
    $[61] = t25;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== t14 || $[65] !== t24 || $[66] !== t27 || $[67] !== t5) {
    t28 = [t2, t5, t14, t24, t27];
    $[64] = t14;
    $[65] = t24;
    $[66] = t27;
    $[67] = t5;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  const columns = t28;
  let t29;
  if ($[69] !== columns || $[70] !== statistics) {
    t29 = <TabTable columns={columns} data={statistics} />;
    $[69] = columns;
    $[70] = statistics;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  let t30;
  if ($[72] !== filter || $[73] !== statistics.commonAverageInOrder || $[74] !== statistics.commonGross || $[75] !== statistics.currency || $[76] !== t29) {
    t30 = <StatisticsTabTableLayout filter={filter} setFilter={setFilter} currency={statistics.currency} totalSales={statistics.commonGross} averageCartValue={statistics.commonAverageInOrder}>{t29}</StatisticsTabTableLayout>;
    $[72] = filter;
    $[73] = statistics.commonAverageInOrder;
    $[74] = statistics.commonGross;
    $[75] = statistics.currency;
    $[76] = t29;
    $[77] = t30;
  } else {
    t30 = $[77];
  }
  return t30;
}
function _temp7(funnelStep_5) {
  return <span className="truncate font-normal">{funnelStep_5.salesRate ? `${funnelStep_5.salesRate}%` : "-"}</span>;
}
function _temp6(funnelStep_4) {
  return <span className="truncate font-normal">{funnelStep_4.salesCount || "-"}</span>;
}
function _temp5(funnelStep_3) {
  return <span className="truncate font-normal">{funnelStep_3.optInRate}%</span>;
}
function _temp4(funnelStep_2) {
  return <span className="truncate font-normal">{funnelStep_2.optInAll}</span>;
}
function _temp3(funnelStep_1) {
  return <span className="truncate">{funnelStep_1.pageViewsUnique}</span>;
}
function _temp2(funnelStep_0) {
  return <span className="font-inter text-text-primary truncate text-base font-semibold">{funnelStep_0.name}</span>;
}
function _temp(funnelStep) {
  return <span className="group:justify-start truncate">{funnelStep.name}</span>;
}
export default StatisticsTab;